module.exports = __webpack_public_path__ + "images/diners-club-international-2-PVvkF.svg";